import React from 'react'
import {Route, Switch, useRouteMatch} from 'react-router-dom'
import {useWallet} from 'use-wallet'

import chef from '../../assets/img/chef.png'

import Button from '../../components/Button'
import Page from '../../components/Page'
import PageHeader from '../../components/PageHeader'
import WalletProviderModal from '../../components/WalletProviderModal'

import useModal from '../../hooks/useModal'


import FarmCards from './components/FarmCards'
import Spacer from "../../components/Spacer";
import {AppConfig} from "../../config";
import Countdown, {zeroPad} from "react-countdown";
import styled from "styled-components";

const Farms: React.FC = () => {
    const {path} = useRouteMatch();
    const {account} = useWallet();
    const [onPresentWalletProviderModal] = useModal(<WalletProviderModal/>);
    return (
        <Switch>
            <Page>
                {!!account ? (
                    <>
                        <Route exact path={path}>
                            <PageHeader
                                icon={<img src={chef} height="120"/>}
                                subtitle="Nsure Underwriter Program"
                                title="Select Your Favorite Dishes"
                            >
                                <TimeOutStyle>
                                    {
                                        new Date().getTime()>AppConfig.unlockStaking.getTime()?
                                            <Countdown
                                                date={AppConfig.unlockIn}
                                                renderer={renderers}
                                            /> : <Countdown
                                                date={AppConfig.unlockStaking}
                                                renderer={renderer}
                                            />
                                    }

                                </TimeOutStyle>

                            </PageHeader>

                            {/*<Spacer/>*/}
                            {/*<FarmCards/>*/}
                        </Route>
                    </>
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            onClick={onPresentWalletProviderModal}
                            text="🔓 Unlock Wallet"
                        />
                    </div>
                )}
            </Page>
        </Switch>
    )
};

export default Farms

// @ts-ignore
const renderer = ({days, hours, minutes, seconds, completed}) => {

    return (
        <>
            <h2>Rebalance Period - Time Remaining</h2>
            <div>

                <div>
                    <h4>{zeroPad(days)}</h4>
                    <p>Days</p>
                </div>
                <div>
                    <h4>{zeroPad(hours)}</h4>
                    <p>Hours</p>
                </div>
                <div>
                    <h4>{zeroPad(minutes)}</h4>
                    <p>Minutes</p>
                </div>
                <div>
                    <h4>{zeroPad(seconds)}</h4>
                    <p>Seconds</p>
                </div>

            </div>
        </>
    );
};




// @ts-ignore
const renderers = ({days, hours, minutes, seconds, completed}) => {
    return (
        <>
            <h2>Closed, please do underwriting in</h2>
            <a href="https://app.nsure.network/#/start_list/underwriting/">Underwriting</a>
            {/*<div>*/}

            {/*    <div>*/}
            {/*        <h4>{zeroPad(days)}</h4>*/}
            {/*        <p>Days</p>*/}
            {/*    </div>*/}
            {/*    <div>*/}
            {/*        <h4>{zeroPad(hours)}</h4>*/}
            {/*        <p>Hours</p>*/}
            {/*    </div>*/}
            {/*    <div>*/}
            {/*        <h4>{zeroPad(minutes)}</h4>*/}
            {/*        <p>Minutes</p>*/}
            {/*    </div>*/}
            {/*    <div>*/}
            {/*        <h4>{zeroPad(seconds)}</h4>*/}
            {/*        <p>Seconds</p>*/}
            {/*    </div>*/}

            {/*</div>*/}
        </>
    );
};

const TimeOutStyle = styled.div`
color: white;
  text-align: center;
h2{

padding: 10px 0;
font-weight: 400;
}
  a{
    color: RGBA(46,162,248,1);
    text-decoration: none;
  }
div{
  display: flex;
  div{
  flex-flow: column;
  width: 80px;
  margin-right: 10px;
  &:last-child{
  margin-right: 0;
  }
  h4{
  padding: 10px;
  border-radius: 5px;
  background-color: #17254A;
  text-align: center;
  line-height: 1;
  }
  p{
  text-align: center;
  margin-top: 5px;
  font-size: 10px;
  }
  }
}
`
